export const parsePodsList = inputText => {
    const normalizedText = String(inputText ?? '').trim()
    if (!normalizedText) return []

    return normalizedText
      .split(/[,\n;\r]+/g)
      .map(pod => pod.trim())
      .filter(pod => pod.length > 0)
}

export const canSubmitPodUpdater = ({ providerUuid, podsText }) =>
  Boolean(providerUuid) && parsePodsList(podsText).length > 0

export const mapProvidersToSelectOptions = providers =>
  (Array.isArray(providers) ? providers : []).map(provider => ({
    id: String(provider?.uuid ?? provider?.id ?? ''),
    label: String(provider?.name ?? ''),
    uuid: String(provider?.uuid ?? ''),
    name: String(provider?.name ?? ''),
    raw: provider,
  })).filter(provider => provider.id && provider.label)


